








































































































import { Component, Vue } from 'vue-property-decorator';

// Vue elements
// import IntroVue from '../components/Intro.vue';

import Preloader from '../../utils/preloader';
import sleep from '../../utils/sleep';

import Game from '@/engine/Game';
import gaLog from '../../utils/ga';


@Component({
    components: {
    },
})
export default class MainPage extends Vue {

    loaded = false;

    mounted(){

        console.log("app");

        this.waitLoad();

        // TODO: rm
        //this.game = createGame();


    }

    async waitLoad(){

        await Preloader.preloadFolder('fonts');
        await Preloader.preloadFolder('base');
        await Preloader.preloadFolder('puzzles');
        this.loaded = true;

    }


    single_game(){

        const game = Game.new();
        this.$router.push('/game');

        gaLog('single-game');

    }

    multiplayer_game(){

        this.$router.push('/multiplayer')
        gaLog('multiplayer-game');

    }



}

